/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {  leaveType, changeDisplayedName } from "../../../common";
import Form, {
  Item,
  RequiredRule,
  Label,
  StringLengthRule,
} from "devextreme-react/form";
import { DateBox, SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import "./style.scss";

function FormApprovalSetting({
  user,
  formData,
  symbol,
  employee,
  setEmployeeOid,
  employeeOid,
}) {
  const [isSelectHour, setIsSelectHour] = useState(false);
  const [valueLeaveType, setValueLeaveType] = useState("");
  // const [leaveRegistration, setLeaveRegistration] = useState({});
  const [toDate, setToDate] = useState();

  // useEffect(() => {
  //   const getLeaveRegistration = async () => {
  //     const { data } = await axios.get("LeaveRegistration", {
  //       params: {
  //         $filter: `Employee/Oid eq ${user.EmployeeOid} eq true`,
  //         $count: true,
  //       },
  //     });
  //     setLeaveRegistration(data.value[0]);
  //     return data.value;
  //   };
  //   getLeaveRegistration();
  // }, []);
  function gridBoxSymbolDisplayExpr(item) {
    return item && `${item.SymbolCode} - ${item.SymbolName}`;
  }
  const symbolEditorOptions = {
    items: symbol,
    searchEnabled: true,
    placeholder: formatMessage("PlaceholderSymbol"),
    displayExpr: gridBoxSymbolDisplayExpr,
    valueExpr: "Oid",
    searchExpr: "SymbolName",
    searchMode: "contains",
    showClearButton: true,
    onValueChanged: (e) => {
      formData.current.SymbolOid = e.value;
    },
  };
  function gridBoxDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }
  const leaveTypeEditorOptions = {
    items: leaveType,
    value: valueLeaveType,
    searchEnabled: true,
    placeholder: formatMessage("PlaceholderLeaveType"),
    valueExpr: "id",
    displayExpr: changeDisplayedName(),
    showClearButton: true,
    onValueChanged: (e) => {
      if (e.value === 3) {
        setValueLeaveType(e.value);
        setIsSelectHour(true);
      } else {
        setValueLeaveType(e.value);
        setIsSelectHour(false);
      }
    },
  };

  return (
    <div className="d-flex form-leave-registration">
      <Form
        colCount={1}
        id="form-leave"
        formData={formData.current}
        className={"form-editor"}
      >
        {user.IsDeclarant === "True" && (
          <Item dataField="Employee">
            <SelectBox
              valueExpr="Oid"
              dataSource={employee}
              value={employeeOid}
              displayExpr={gridBoxDisplayExpr}
              itemRender={gridBoxDisplayExpr}
              onValueChanged={(e) => {
                setEmployeeOid(e.value);
              }}
              searchEnabled={true}
            />
            <Label text={formatMessage("Employee")} />
            <RequiredRule message={formatMessage("ValidateEmployee")} />
          </Item>
        )}
        <Item
          dataField="Symbol"
          editorType="dxSelectBox"
          editorOptions={symbolEditorOptions}
        >
          <Label text={formatMessage("Symbol")} />
          <RequiredRule message={formatMessage("ValidateSymbol")} />
        </Item>
        <Item
          dataField="LeaveType"
          editorType="dxSelectBox"
          editorOptions={leaveTypeEditorOptions}
        >
          <Label text={formatMessage("LeaveType")} />
          <RequiredRule message={formatMessage("ValidateLeaveType")} />
        </Item>
        <Item
          dataField="FromDate"
          editorType="dxDateBox"
          editorOptions={{
            onValueChanged: (e) => {
              formData.current.ToDate = e.value;
              setToDate(e.value);
            },
          }}
        >
          <Label text={formatMessage("FromDate")} />
          <RequiredRule message={formatMessage("ValidateFromDate")} />
        </Item>
        <Item
          dataField="ToDate"
          editorType="dxDateBox"
          editorOptions={{
            value: toDate,
          }}
        >
          <Label text={formatMessage("ToDate")} />
          <RequiredRule message={formatMessage("ValidateToDate")} />
        </Item>
        {isSelectHour && (
          <Item dataField="StartTime">
            <DateBox
              onValueChanged={(e) => {
                formData.current.StartTime = e.value;
              }}
              dataField="StartTime"
              type="time"
            >
              <Label text={formatMessage("StartTime")} />
              <RequiredRule message={formatMessage("ValidateStartTime")} />
            </DateBox>
          </Item>
        )}
        {isSelectHour && (
          <Item dataField="EndTime">
            <DateBox
              onValueChanged={(e) => {
                formData.current.EndTime = e.value;
              }}
              dataField="EndTime"
              type="time"
            >
              <Label text={formatMessage("EndTime")} />
              <RequiredRule message={formatMessage("ValidateEndTime")} />
            </DateBox>
          </Item>
        )}
        <Item dataField="Description" editorType="dxTextArea">
          <StringLengthRule max="250" />
          <Label text={formatMessage("Description")} />
        </Item>
      </Form>

      
    </div>
  );
}

export default  React.memo(FormApprovalSetting);